import React, { Component } from "react";
import { BsyUtils } from "../../utils/Utils";
import BsyRadioGroup from '../BsyRadioGroup';

export default class AddRoleDeptPane extends Component{
    constructor(props) {
        super(props);
        this.state = {
            coopName: "",
            coopInputError: false,
            corpId: null,
            isCoop: props.isCoop,
            dept_id_list: [],
            dock_corpid: [],
            is_global_docker: true,
            selectGroup: props.selectGroup || "",
            corpList: props.corpList || {},
            deptMap: {},
            corpLabelMap: {}
        }
        this.inputRef = React.createRef();
    }

    componentDidMount(){
        this.props.getEl && this.props.getEl(this);
    }

    handleChange = (event) =>{
        this.setState({
            coopInputError: event.target.value === "",
            coopName: event.target.value
        })
    }

    handleBlur = (event) =>{
        this.setState({
            coopInputError: event.target.value === "",
            coopName: event.target.value
        })
    }

    _createChangeDepartmentBubble = () =>{
        const {dock_corpid} = this.state;
        const _this = this;
        const d = new window.FX.ConfirmDialog({
            title: React.language("contact.corp.list"),
            height: 576,
            width: 710,
            contentWidget: {
                rowSize: [440],
                colSize: [680],
                padding: 15,
                items: [[{
                    widgetName: "memberSelect",
                    type: "memberselectpane",

                    editable: !0,
                    hasMenuType:false,
                    memberEnable: !1,
                    departmentEnable: !1,
                    outsiderMemberEnable: !1,
                    outsiderGroupEnable: !1,
                    roleEnable: !1,
                    corpEnable: !0,
                    dynamicEnable: !1,
                    dynamicType: "set",
                    value: dock_corpid
                }]]
            },
            onOk: function () {
                var dept = d.getWidgetByName("memberSelect");
                var d1 = dept.getAllJsonValue();
                let corpLabelMap = {};
                let corpId = d1.dockcorpValue.map(res=>{
                    return res.indexOf("-") > -1 ? res.split("-")[0] : res;
                })
                d1.corpLabelMap.map(res=>{
                    if(corpId.indexOf(res._id) > -1){
                        corpLabelMap[res._id] = res;
                    }
                })
                _this.setState({dock_corpid: d1.dockcorpValue, corpLabelMap});
                return !1;
            }
        });
        d.show()
    }

    _createCorpUserBubble = () =>{
        const {dept_id_list} = this.state;
        const _this = this;
        var e = new window.FX.ConfirmDialog({
            title: React.language("widget.user.listTitle"),
            height: 586,
            width: 956,
            contentWidget: {
                rowSize: [450],
                colSize: [926],
                padding: 15,
                items: [[{
                    widgetName: "memberSelect",
                    type: "memberselectpane",

                    editable: !0,
                    roleEnable: 0,
                    hasMenuType:false,
                    hasDock: false,
                    memberEnable: !1,
                    departmentEnable: !0,
                    hasTeamManageBtn: !1,
                    outsiderMemberEnable: !1,
                    outsiderGroupEnable: !1,
                    value: dept_id_list,
                }]]
            },
            onOk: function () {
                let dept = e.getWidgetByName("memberSelect");
                let d1 = dept.getAllJsonValue();
                let deptMap = {};
                d1.newDepartments.map(res=>{
                    if(d1.departs.indexOf(res._id) > -1){
                        deptMap[res._id] = res;
                    }
                })
                _this.setState({dept_id_list: d1.departs, deptMap});
                return !1
            }
        });
        e.show()
    }

    render(){
        const {dept_id_list, is_global_docker, dock_corpid, corpLabelMap, deptMap} = this.state;
        return (
            <div className="AddRoleDeptPane">
                <div className="pane-item coopName">
                    <div className="item-label">
                        <span className="label-req">*</span>
                        <span className="label-name">{React.language('contact.docking.dept')}</span>
                    </div>
                    <div className="item-cont">
                        <div className="select-list" onClick={this._createCorpUserBubble}>
                            {
                                (dept_id_list && dept_id_list.length > 0) ? dept_id_list.map(res => {
                                    let name = deptMap[res] ? deptMap[res].name : "";
                                    return deptMap[res] && <div className="item-content department"><div className="avatar">
                                        <i className="icon-department"></i>
                                    </div><span>{name}</span></div>
                                }) : <div className="list-empty">
                                    <span className="empty-tip">{React.language('contact.docking.dept.require')}</span>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className="pane-item corp">
                    <div className="item-label">
                        <span className="label-name">{React.language('contact.docking.corp')}</span>
                    </div>
                    <BsyRadioGroup
                        layout={'horizontal'}
                        value={is_global_docker}
                        items={[{
                            value: true,
                            text: React.language('contact.corp.all'),
                        }, {
                            value: false,
                            text: React.language('contact.corp.some'),
                        }]}
                        onStopEdit={(e) => {
                            this.setState({
                                is_global_docker:e
                            })
                        }}
                    ></BsyRadioGroup>
                    {!is_global_docker && <div className="item-cont">
                        <div className="select-list" onClick={this._createChangeDepartmentBubble}>
                            {
                                (dock_corpid && dock_corpid.length > 0) ? dock_corpid.map(res => {
                                    let id = res.indexOf('-') > -1 ? res.split('-')[0] : res;
                                    let name = corpLabelMap[id] ? corpLabelMap[id].name : "";
                                    return name ? <div className="item-content department"><i className="icon-all-corp" /><span>{name}</span></div> : ""
                                }) : <div className="list-empty">
                                    <span className="empty-tip">{React.language('label.select1')}</span>
                                </div>
                            }
                        </div>
                    </div>}
                </div>
            </div>
        )
    }
}